import { datadogLogs } from '@datadog/browser-logs'
import React from 'react'

import Spinner from '../../components/spinner/Spinner'
import { SpinnerContainer } from '../../pages/showroom/vehicle-list/VehicleList.styled'
import { getAuthOperation, safeReturnTo } from './authOperation'

const messages: Record<string, [string, string]> = {
  en: ['Authentication could not be completed.', 'Try again'],
  de: ['Die Anmeldung konnte nicht abgeschlossen werden.', 'Erneut versuchen'],
  pt: ['Não foi possível concluir a autenticação.', 'Tentar novamente'],
  no: ['Innloggingen kunne ikke fullføres.', 'Prøv igjen'],
  nb: ['Innloggingen kunne ikke fullføres.', 'Prøv igjen'],
  fr: ['L’authentification n’a pas pu aboutir.', 'Réessayer'],
  da: ['Login kunne ikke gennemføres.', 'Prøv igen'],
  sv: ['Inloggningen kunde inte slutföras.', 'Försök igen'],
}

export const AuthLoading = () => (
  <SpinnerContainer data-testid="authentication-spinner" role="status">
    <Spinner size={20} />
  </SpinnerContainer>
)

export const AuthFailure = () => {
  const operation = getAuthOperation()
  const locale =
    operation?.appState.locale || window.location.pathname.split('/')[1] || 'en'
  const [message, retry] = messages[locale.split(/[-_]/)[0]] || messages.en
  const retryTo =
    operation?.kind === 'reset' || operation?.kind === 'reset-logout'
      ? `/password-reset?language=${encodeURIComponent(locale)}`
      : safeReturnTo(operation?.appState.returnTo)
  return (
    <div role="alert">
      {message} <a href={retryTo}>{retry}</a>
    </div>
  )
}

export class AuthInitializationBoundary extends React.Component<
  { children: React.ReactNode },
  { failed: boolean }
> {
  state = { failed: false }

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true }
  }

  componentDidCatch(error: Error): void {
    datadogLogs.logger.error('Authentication initialization failed', { error })
  }

  render(): React.ReactNode {
    return this.state.failed ? <AuthFailure /> : this.props.children
  }
}
